export default "__VITE_ASSET__BoPMfnG$__"